import React, { Component } from 'react';

import Slider from 'react-slick';
import Dom from '../../utils/Dom';
import AspectRatioContainer from '../aspect-ratio-container/AspectRatioContainer';
import Constants from '../../Constants';
import EirValidImage from '../eir-valid-image/EirValidImage';

class DeviceCarousel extends Component {
  constructor(props) {
    super(props);
    Dom.addStyleSheet(Constants.externalCss.slickCarousel.minified);
    Dom.addStyleSheet(Constants.externalCss.slickCarousel.themeMinified);
    this.state = {
      settings: {
        dots: true,
        speed: 500,
        focusOnSelect: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        centerMode: true,
        respondTo: 'window',
        variableWidth: false,
        centerPadding: '0',
        slideHeight: 0,
        fade: true
      }
    };
  }

  componentWillMount() {}
  render() {
    return (
      <div className="device-carousel-container">
        <div className="device-circle-container">
          <div className="device-circle" />
        </div>
        <div className="eir-fluid-xs-w75 eir-fluid-sm-w75 eir-fluid-md-w75 eir-fluid-lg-w33 mx-auto">
          <Slider {...this.state.settings}>
            {this.props.images.length>0?(this.props.images.map(image => (
              <AspectRatioContainer
                className="device-carousel-container"
                xs="10-16"
              >
                <EirValidImage
                  className="img-fluid"
                  src={image.path}
                  fallbackSrc="/.galleries/eir/devices/handset_not_found.png"
                />
              </AspectRatioContainer>
            ))):
            <AspectRatioContainer
            className="device-carousel-container"
            xs="10-16"
          >
            <EirValidImage
              className="img-fluid"
              src="/.galleries/eir/devices/handset_not_found.png"
              fallbackSrc="/.galleries/eir/devices/handset_not_found.png"
            />
          </AspectRatioContainer>
          
          }
          </Slider>
        </div>
        {this.props.children}
      </div>
    );
  }
}

export default DeviceCarousel;
